<div class="tooltip-container" [ngClass]="'tooltip-' + position">
    <ng-content></ng-content> <!-- Slot for the help icon -->
    <span class="tooltip-text">{{ text }}</span>
  </div>
  